// The single German catalog of the whole frontend, assembled from one file per domain. Both apps
// register it as their default `translation` namespace (see each app's i18n.config.ts), so shared
// and app code read the same keys through a plain useTranslation() — there is exactly one place
// for strings and one namespace.
import accountSetup from "./de/accountSetup";
import ambulanzes from "./de/ambulanzes";
import app from "./de/app";
import assignments from "./de/assignments";
import attendanceList from "./de/attendanceList";
import auth from "./de/auth";
import calculators from "./de/calculators";
import calendar from "./de/calendar";
import changeHistory from "./de/changeHistory";
import claims from "./de/claims";
import client1bForm from "./de/client1bForm";
import clientAccess from "./de/clientAccess";
import clients from "./de/clients";
import common from "./de/common";
import counselors from "./de/counselors";
import courtHearings from "./de/courtHearings";
import documentPreview from "./de/documentPreview";
import documents from "./de/documents";
import dropzone from "./de/dropzone";
import dutySchedule from "./de/dutySchedule";
import edicts from "./de/edicts";
import exchange from "./de/exchange";
import fileUpload from "./de/fileUpload";
import internetRegistrations from "./de/internetRegistrations";
import layout from "./de/layout";
import mailMerge from "./de/mailMerge";
import placeholders from "./de/placeholders";
import portal from "./de/portal";
import portalAccess from "./de/portalAccess";
import priorityRequests from "./de/priorityRequests";
import proceedingParticipants from "./de/proceedingParticipants";
import settings from "./de/settings";
import spousalMaintenance from "./de/spousalMaintenance";
import takeover from "./de/takeover";
import upload from "./de/upload";
import userSettings from "./de/userSettings";
import volunteerAssignment from "./de/volunteerAssignment";
import volunteerPortal from "./de/volunteerPortal";
import volunteers from "./de/volunteers";

// Deliberately not `as const`: literal string types would make every t() argument a giant union
// and slow the compiler; key checking comes from the object SHAPE via CustomTypeOptions.
export const messagesDe = {
  accountSetup,
  ambulanzes,
  app,
  assignments,
  attendanceList,
  auth,
  calculators,
  calendar,
  changeHistory,
  claims,
  client1bForm,
  clientAccess,
  clients,
  common,
  counselors,
  courtHearings,
  documentPreview,
  documents,
  dropzone,
  dutySchedule,
  edicts,
  exchange,
  fileUpload,
  internetRegistrations,
  layout,
  mailMerge,
  placeholders,
  portal,
  portalAccess,
  priorityRequests,
  proceedingParticipants,
  settings,
  spousalMaintenance,
  takeover,
  upload,
  userSettings,
  volunteerAssignment,
  volunteerPortal,
  volunteers,
};
